import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a8d295a")

_pushScopeId("data-v-1a8d295a")
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/_createVNode("a", {
  class: "brand",
  href: "#"
}, "AdConnect", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", { class: "divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", null, [
      _hoisted_2,
      _hoisted_3,
      _createVNode("li", null, [
        _createVNode(_component_router_link, { to: "/home" }, {
          default: _withId(({ isActive }) => [
            _createVNode("span", { active: isActive }, _toDisplayString(_ctx.$t("dashboard")), 9, ["active"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
})